import { render, staticRenderFns } from "./extratoEmpresa.vue?vue&type=template&id=74ee0971&"
import script from "./extratoEmpresa.vue?vue&type=script&lang=js&"
export * from "./extratoEmpresa.vue?vue&type=script&lang=js&"
import style0 from "./extratoEmpresa.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports